import _get from 'lodash/get';
import { TaskEarlyCompletionUnitEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';

const getEarlyCompletionFields = (values: Values) => {
  const enable = _get(values, FieldNames.earlyCompletionEnabled, false);
  const unit = _get(
    values,
    `${FieldNames.earlyCompletionType}.value`,
  ) as TaskEarlyCompletionUnitEnum;
  const amount = _get(values, FieldNames.earlyCompletionAmount, 0) as number;
  if (enable) {
    return {
      earlyCompletion: +amount,
      earlyCompletionUnit: unit,
    };
  }
  return {};
};

export default getEarlyCompletionFields;
